import { connect } from "react-redux";
import { withRouter } from "tools/routerCompat";
import {
  getLoginStatistics,
  getUser,
  sendPasswordResetLink
} from "actions/user";
import {
  getCaseTimeLogByUserPayPeriod,
  getPayPeriodList,
  updateCaseTimeLog,
  deleteCaseTimeLog,
  addCaseTimeLog
} from "actions/casetimelog";
import {
  getTimeClockByPayPeriod,
  addTimeClock,
  deleteTimeClock,
  updateTimeClock,
} from "actions/account";
import { AgentProfile } from "../../components/QualityAssurance/Agent";

const mapStateToProps = state => {
  return {
    loginStatistics: state.user.loginStatistics,
    isFetchingLoginStatistics: state.user.isFetchingLoginStatistics,
    internetUserId: state.user.internetUserId,
    isFetchingInternetUser: state.user.isFetchingInternetUser,
    internetUser: state.user.internetUser,
    payPeriods: state.caseTimeLog.payPeriods,
    timeClockByPayPeriod: state.user.timeClockByPayPeriod,
    isFetchingTimeClockByPayPeriod: state.user.isFetchingTimeClockByPayPeriod,
    isAddingTimeClock: state.user.isAddingTimeClock,
    isDeletingTimeClock: state.user.isDeletingTimeClock,
    isUpdatingTimeClock: state.user.isUpdatingTimeClock,
    isUpdatingTimeLogs: state.caseTimeLog.isUpdatingTimeLogs,
    isDeletingTimeLogs: state.caseTimeLog.isDeletingTimeLogs,
    isAddingTimeLogs: state.caseTimeLog.fetching,
    isFetchingPayPeriods: state.caseTimeLog.isFetchingPayPeriods,
    timeLogs: state.caseTimeLog.timeLogs,
    isFetchingTimeLogs: state.caseTimeLog.isFetchingTimeLogs,
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps
  };
};

const mapDispatchToProps = dispatch => ({
  getLoginStatistics(internetUserId) {
    dispatch(getLoginStatistics(internetUserId));
  },
  getUser(id) {
    dispatch(getUser(id));
  },
  sendPasswordResetLink(username) {
    dispatch(sendPasswordResetLink(username));
  },
  getCaseTimeLogByUserPayPeriod(internetUserId, payPeriodId) {
    dispatch(getCaseTimeLogByUserPayPeriod(internetUserId, payPeriodId));
  },
  getPayPeriodList() {
    dispatch(getPayPeriodList());
  },
  getTimeClockByPayPeriod(internetUserId, payPeriodId) {
    dispatch(getTimeClockByPayPeriod(internetUserId, payPeriodId));
  },
  addTimeClock(internetUserId, dto) {
    dispatch(addTimeClock(internetUserId, dto));
  },
  deleteTimeClock(id) {
    dispatch(deleteTimeClock(id));
  },
  updateTimeClock(id, clockIn, clockOut) {
    dispatch(updateTimeClock(id, clockIn, clockOut));
  },
  updateCaseTimeLog(updatedCaseTimeLog, updateTimeLogFunc) {
    dispatch(updateCaseTimeLog(updatedCaseTimeLog, updateTimeLogFunc));
  },
  deleteCaseTimeLog(id) {
    dispatch(deleteCaseTimeLog(id));
  },
  addCaseTimeLog(dto) {
    dispatch(addCaseTimeLog(dto));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(withRouter(AgentProfile));
